var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenericHuman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 115,
    viewBox: "0 0 98 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 0C35.525 0 24.5 11.025 24.5 24.5C24.5 37.975 35.525 49 49 49C62.475 49 73.5 37.975 73.5 24.5C73.5 11.025 62.475 0 49 0Z",
    fill: "#6B00DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 115H98V88.0175C98 78.095 91.875 69.275 83.055 65.355C72.6425 60.8225 61.25 58.25 49 58.25C36.75 58.25 25.3575 60.8225 14.945 65.355C6.125 69.275 0 78.095 0 88.0175V115Z",
    fill: "#6B00DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericHuman);
export default __webpack_public_path__ + "static/media/generic-human.00892d065af75f9d0dac7c9c7b506ad0.svg";
export { ForwardRef as ReactComponent };